var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTimeEngine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg_icon",
    viewBox: "0 0 27.3 27.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#243A53;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.3,12.5v2H13.6l-.7.2h0a1.2,1.2,0,0,1-1.2-1.3,1.4,1.4,0,0,1,.2-.6V4.6h2v7.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.3,21.3A11.1,11.1,0,0,1,2.7,9.6L.8,8.9a13.3,13.3,0,0,0,3,13.9,13.6,13.6,0,0,0,9.3,3.8l2.1-.2-.3-1.9A11.4,11.4,0,0,1,5.3,21.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.5,4.5h-3L8.6,3.3a10.4,10.4,0,0,1,2.5-.8,11.1,11.1,0,0,1,13,12.7l2,.3A12.8,12.8,0,0,0,22.4,4.2,13,13,0,0,0,10.7.6a9.8,9.8,0,0,0-2.9.9A10,10,0,0,0,5,3.2V0H3V6.5H9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.3,22.4,25.9,22a5.3,5.3,0,0,0-.6-2.4l1-1-1.4-1.4-1.1,1a4.6,4.6,0,0,0-2.3-.6l-.4-1.4-2,.5.4,1.4-1,.8a3.6,3.6,0,0,0-.7,1l-1.5-.4-.5,1.9,1.5.4a4.1,4.1,0,0,0,.6,2.4l-1.1,1,1.5,1.4,1-1a4.6,4.6,0,0,0,2.3.6h.1l.4,1.5,1.9-.5-.4-1.5,1-.7h0l.8-1,1.4.4Zm-3.5.1a2.4,2.4,0,0,1-.6,1.1l-1,.6a2.7,2.7,0,0,1-2.3-.6,2.4,2.4,0,0,1-.5-2.3,1.9,1.9,0,0,1,.5-1,2.4,2.4,0,0,1,1.1-.6h.6a2,2,0,0,1,1.6.7A2.3,2.3,0,0,1,23.8,22.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimeEngine);
export default __webpack_public_path__ + "static/media/icon-time-engine.29d88f766ceefbc2983bebe50ffa487d.svg";
export { ForwardRef as ReactComponent };